import { CompensationCalculator } from "./CompensationCalculator";
import type { CompensationCalculatorProps } from "./types";

export { CompensationCalculator, type CompensationCalculatorProps };
